import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Link = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='m6.094 11.75-.667.666a4.714 4.714 0 1 0 6.667 6.667l1.333-1.334a4.714 4.714 0 0 0 0-6.666'
          stroke='currentColor'
          strokeWidth='1.414'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='m18.094 13.082.666-.666a4.714 4.714 0 1 0-6.666-6.667L10.76 7.082a4.714 4.714 0 0 0 0 6.667'
          stroke='currentColor'
          strokeWidth='1.414'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.927 12.916a4.007 4.007 0 0 0 5.667 5.667l1.333-1.333a4.007 4.007 0 0 0 0-5.667.707.707 0 1 1 1-1 5.42 5.42 0 0 1 0 7.667l-1.333 1.333a5.421 5.421 0 0 1-7.667-7.667l.667-.666a.707.707 0 1 1 1 1z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M18.26 11.916a4.007 4.007 0 1 0-5.666-5.667L11.26 7.583a4.007 4.007 0 0 0 0 5.666.707.707 0 1 1-1 1 5.42 5.42 0 0 1 0-7.666l1.334-1.334a5.421 5.421 0 0 1 7.666 7.667l-.666.667a.707.707 0 0 1-1-1z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
